import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ef-authorizenet-checkout-feature',
  templateUrl: './authorizenet-checkout-feature.component.html',
  styleUrls: ['./authorizenet-checkout-feature.component.scss'],
  standalone: false
})
export class AuthorizenetCheckoutFeatureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
